import { isDefined } from "@clipboard-health/util-ts";

interface GetWorkplaceConfiguredQualificationsParams {
  rates: Record<string, number> | undefined;
}

export function getWorkplaceConfiguredQualifications({
  rates,
}: GetWorkplaceConfiguredQualificationsParams): string[] {
  if (!isDefined(rates)) {
    return [];
  }

  return Object.entries(rates)
    .filter(([, rate]) => rate !== 0)
    .map(([qualification]) => qualification);
}

interface GetWorkerWorkplaceConfiguredQualificationsParams {
  workerQualifications?: string[];
  workplaceConfiguredQualifications: string[];
}

export function getWorkerWorkplaceConfiguredQualifications({
  workerQualifications,
  workplaceConfiguredQualifications,
}: GetWorkerWorkplaceConfiguredQualificationsParams): string[] {
  if (!workerQualifications) {
    return [];
  }
  return workerQualifications.filter((qualification) =>
    workplaceConfiguredQualifications.includes(qualification)
  );
}
